module.exports = __webpack_public_path__ + "media/banners/opony-felgi-baner-40701880.png";